import {
    CHECK_SESSION,
    LIST_ADMIN,
    MODIFY_ADMIN,
    DELETE_ADMIN,
    FIND_ADMIN,
    UPDATE_ADMIN,
    REGISTER_ADMIN,
    LOGIN_ADMIN,
    AUTH_ADMIN,
    LOGOUT_ADMIN,
    FIND_SENSOR,
    FIND_USER,
    UPDATE_USER,
    REGISTER_USER,
    FIND_SETTING,
    UPDATE_SETTING,
    REGISTER_SETTING,
    FIND_DEVICE,
    UPDATE_DEVICE,
    REGISTER_DEVICE,
    LIST_USER,
    DELETE_USER,
    SEARCH_LIST,
    SEARCH_DEVICE,
    DEVICE_LIST,
    MODIFY_USER,
    UPDATE_SENSOR,
    UPDATE_POWER
} from '../_actions/types';

export default function (state = {}, action) {
    switch (action.type) {
        case CHECK_SESSION:
            return { ...state, checkSuccess: action.payload }
        case LIST_ADMIN:
            return { ...state, listSuccess: action.payload }
        case MODIFY_ADMIN:
            return { ...state, modifySuccess: action.payload }
        case DELETE_ADMIN:
            return { ...state, deleteSuccess: action.payload }
        case FIND_ADMIN:
            return { ...state, findSuccess: action.payload }
        case UPDATE_ADMIN:
            return { ...state, updateSuccess: action.payload }
        case REGISTER_ADMIN:
            return { ...state, registerSuccess: action.payload }
        case LOGIN_ADMIN:
            return { ...state, loginSuccess: action.payload }
        case AUTH_ADMIN:
            return { ...state, userData: action.payload }
        case LOGOUT_ADMIN:
            return { ...state, logoutSuccess: action.payload }
        case FIND_SENSOR:
            return { ...state, findSuccess: action.payload }
        case FIND_USER:
            return { ...state, findSuccess: action.payload }
        case UPDATE_USER:
            return { ...state, updateSuccess: action.payload }
        case REGISTER_USER:
            return { ...state, registerSuccess: action.payload }
        case FIND_SETTING:
            return { ...state, findSuccess: action.payload }
        case UPDATE_SETTING:
            return { ...state, updateSuccess: action.payload }
        case REGISTER_SETTING:
            return { ...state, registerSuccess: action.payload }
        case FIND_DEVICE:
            return { ...state, findSuccess: action.payload }
        case UPDATE_DEVICE:
            return { ...state, updateSuccess: action.payload }
        case REGISTER_DEVICE:
            return { ...state, registerSuccess: action.payload }
        case LIST_USER:
            return { ...state, listSuccess: action.payload }
        case DELETE_USER:
            return { ...state, deleteSuccess: action.payload }
        case SEARCH_LIST:
            return { ...state, listSuccess: action.payload }
        case SEARCH_DEVICE:
            return { ...state, listSuccess: action.payload }
        case DEVICE_LIST:
            return { ...state, listSuccess: action.payload }
        case MODIFY_USER:
            return { ...state, modifySuccess: action.payload }
        case UPDATE_SENSOR:
            return { ...state, updateSuccess: action.payload }
        case UPDATE_POWER:
            return { ...state, updateSuccess: action.payload }
        default:
            return state;
    }
}
